import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { ConfigHelper } from 'src/app/core/services/helpers/config.helper';
import { selectAuthEmail } from 'src/app/state/auth.selectors';
import { selectShoppingCartItemCount } from 'src/app/state/shopping-cart.selectors';
import { BrandEnum } from 'src/app/core/dtos/enum';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

  shoppingCartItemCount$ = this.store.pipe(select(selectShoppingCartItemCount));
  loggedInEmail$ = this.store.pipe(select(selectAuthEmail));
  loggedInEmail: string;
  logo: string;
  url: string;
  hideSignIn: boolean;
  hideSignUp: boolean;
  private authSubscription: Subscription;

  constructor(
    private store: Store,
    private configHelper: ConfigHelper,
    private authenticationService: AuthenticationService,
    private route: Router
  ) { }

  ngOnInit() {
    this.authSubscription = this.loggedInEmail$.subscribe({
      next: x => this.loggedInEmail = x
    });

    switch (this.configHelper.getBrandId()) {
      case BrandEnum.CELPIP: {
        this.logo = 'assets/logo.png';
        this.url = 'https://www.celpip.ca';
        break;
      }
      case BrandEnum.CAEL: {
        this.logo = 'assets/logo-cael.png';
        this.url = 'https://www.cael.ca';
        break;
      }
      case BrandEnum.LPI: {
        this.logo = 'assets/logo-lpi.png';
        this.url = 'https://www.paragontesting.ca/lpi';
        break;
      }
      default: {
        console.log('unknown brandId');
        break;
      }
    }
    this.route.events.pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((s: NavigationEnd) => {
        this.hideSignUp = false;
        this.hideSignIn = false;
        if (s.url === "/login") {
          this.hideSignIn = true;
        }
        if (s.url === "/create-account" || s.url === "/account/forgot-password") {
          this.hideSignUp = true;
        }
      });
  }

  ngOnDestroy() {
    this.authSubscription?.unsubscribe();
  }

  logout() {
    this.authenticationService.logout();
  }

}
